
'use client'
import './styles.css';

import { Button, DatePicker, Form, Input, InputNumber, Select, Typography, Upload, UploadProps } from "antd"

import { useForm } from "antd/es/form/Form"
import TextArea from 'antd/es/input/TextArea';
import { useEffect, useState } from 'react';
import { start } from 'repl';
import { PleaScheduleModel } from '../../../../../Models/PleaScheduleModel';
import dayjs from 'dayjs';
import { set } from 'react-hook-form';
const { Option } = Select;

export default function PLeaScheduleForm ({ operationCreate, operationEdit, itemEdit, isOpen }: {
    operationCreate: (values: PleaScheduleModel) => Promise<void> ,
    operationEdit: (values: PleaScheduleModel) => Promise<void>,
    itemEdit: PleaScheduleModel | undefined,
    isOpen: (value: boolean) => void }) {

    const [ form ] = useForm();
    const [startDate, setStartDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>();
   
    const handleDuration = () => {
        if(form.getFieldValue('startDate') && form.getFieldValue('endDate')) {
            const startDate = new Date(form.getFieldValue('startDate'));
            const endDate = new Date(form.getFieldValue('endDate'));
            const duration = (endDate.getMonth() + 1) - (startDate.getMonth() + 1);
            form.setFieldsValue({ duration: duration });
        }
        else {
            form.setFieldsValue({ duration: 0 });;
        }
    }

    const onFinish = (values: any) => {

        if (itemEdit) {
            values.id = itemEdit.id;
            operationEdit(values);
        }
        else {
            operationCreate(values);
        }
        form.resetFields();
        isOpen(false);
    }

    useEffect(() => {
        if (itemEdit) {
            form.setFieldsValue({
                name: itemEdit.name,
                details: itemEdit.details,
                physicalIndicator: itemEdit.physicalIndicator,
                startDate: dayjs(itemEdit.startDate),
                endDate: dayjs(itemEdit.endDate),
                startMonth: itemEdit.startMonth,
                duration: itemEdit.duration,
                finepDuration: itemEdit.finepDuration
            });
            setStartDate(itemEdit.startDate);
            setEndDate(itemEdit.endDate);
        }
        else {
            form.resetFields();
        }
    }, [itemEdit]);

    useEffect(() => {
        if (startDate && endDate) {
            handleDuration();
        }
    }, [startDate, endDate]);

    return (
        <Form form={form} layout='vertical' onFinish={() => onFinish(form.getFieldsValue())}>
            <div className= 'div-main' >

                <div className= 'div-form' >
                    <div className='div-fields'>
                        <Form.Item name={'startDate'} className='input-date' label="Data de Início :">
                            <DatePicker placeholder="Selecione a data" size='large' style={{width: '100%'}} format='YYYY-MM-DD' className='data-picker' onChange={(date, dateString) => setStartDate(date && typeof dateString === 'string' ? new Date(dateString) : undefined)} />
                        </Form.Item>
                        <Form.Item name={'endDate'} className='input-date' label="Data Final :">
                            <DatePicker placeholder="Selecione a data" size='large' style={{width: '100%'}} format='YYYY-MM-DD' className='data-picker' onChange={(date, dateString) => setEndDate(date && typeof dateString === 'string' ? new Date(dateString) : undefined)} />
                        </Form.Item>
                        <Form.Item name={'startMonth'} className='input-number' label="Mês Inicial(Contar a partir do envio do pleito):">
                            <InputNumber style={{width: '100%'}} size='large' controls={false} value={form.getFieldValue('startMonth')} suffix={"Mês(es)"}/>                                    
                        </Form.Item>
                        <Form.Item name={'duration'} className='input-number' label="Duração em Meses Total:">
                            <InputNumber style={{width: '100%'}} size='large' controls={false} disabled value={form.getFieldValue('duration')} suffix={"Mês(es)"}/>
                        </Form.Item>
                        <Form.Item name={'finepDuration'} className='input-number' label="Duração em Meses Finep:">
                            <InputNumber style={{width: '100%'}} size='large' controls={false} value={form.getFieldValue('finepDuration')} suffix={"Mês(es)"}/>
                        </Form.Item>  
                    </div>
                    

                    <Form.Item name={'name'} label="Nome da Atividade:">
                        <Input placeholder="Digite aqui" size='large' showCount maxLength={60} value={form.getFieldValue('name')}/>
                    </Form.Item>  

                    <Form.Item name={'details'} label="Detalhamento da Atividade:">
                        <TextArea placeholder="Digite seu texto aqui" showCount maxLength={150} value={form.getFieldValue('details')}/>
                    </Form.Item>   
                                    
                    <Form.Item name={'physicalIndicator'} label="Indicador Físico:">
                        <TextArea placeholder="Digite seu texto aqui" showCount maxLength={150} value={form.getFieldValue('physicalIndicator')}/>
                    </Form.Item>
                </div>
                <div className='buttons-footer'>
                    <Button className='button-cancel' size='large' type='default' onClick={() => isOpen(false)}>Cancelar</Button>
                    <Button className='button-submit' size='large' type='primary'  htmlType="submit">{ itemEdit ? 'Editar Etapa' : 'Criar Etapa'}</Button>
                </div>
            </div>
        </Form>

    )
}